import { ChevronRightIcon } from "@heroicons/react/24/solid";

const Step = props => {
  const { active, isLastStep, label, onClick, type, disabled } = props || {};
  const isLabelObject = typeof label === "object" && label !== null;
  const resolvedLabel = isLabelObject ? label?.label : label;
  const resolvedTitle = isLabelObject ? label?.title : undefined;
  // Opt-out of `text-transform: capitalize` and allow free wrapping —
  // intended for long, sentence-style labels (e.g. a Contact Search
  // synopsis used as the breadcrumb root) where forcing each word's
  // first letter to upper-case would distort connectors like
  // "between" or "ordered by", and where truncating with an ellipsis
  // would hide search context.
  const normalCase = isLabelObject ? !!label?.normalCase : false;

  const baseStyle = {
    tabs: {
      className: "font-bold text-xs",
      displayName: resolvedLabel?.label || resolvedLabel,
    },
    default: {
      className: "font-medium text-sm",
      displayName: resolvedLabel,
    },
  };

  const { className: baseClass, displayName } =
    baseStyle[type] || baseStyle.default;
  const className = normalCase
    ? `${baseClass} normal-case whitespace-normal break-words`
    : `${baseClass} capitalize`;

  return (
    <li>
      <div className="flex items-center">
        <a
          onClick={(!disabled && onClick) || null}
          className={`mr-4 ${className} ${
            active ? "text-gray-800" : "text-lightgrey-secondary"
          } ${!disabled && "cursor-pointer hover:text-gray-800"}`}
          aria-current={active ? "page" : undefined}
          title={resolvedTitle}
        >
          {displayName}
        </a>
        {isLastStep && (
          <ChevronRightIcon
            className="h-5 w-5 flex-shrink-0 text-gray-400"
            aria-hidden="true"
          />
        )}
      </div>
    </li>
  );
};

const Breadcrumb = props => {
  const {
    steps = [],
    onChange,
    currentStepIndex,
    type,
    disabled,
  } = props || {};

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol role="list" className="flex items-center space-x-4">
        {steps?.map((item, index) => {
          // Per-step disabled flag (carried on the label-object form)
          // composes with the all-steps `disabled` prop, so a single
          // step can opt out of being clickable without forcing the
          // whole breadcrumb to do so.
          const stepDisabled =
            disabled ||
            (typeof item === "object" && item !== null && !!item?.disabled);
          return (
            <Step
              disabled={stepDisabled}
              type={type}
              key={index}
              active={currentStepIndex === index}
              isLastStep={index < steps.length - 1}
              label={item}
              onClick={() => onChange(index)}
            />
          );
        })}
      </ol>
    </nav>
  );
};

export { Breadcrumb };
